import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  MenuItem,
  Select,
  ListItemText,
  Alert,
  AlertTitle,
  Tooltip,
  IconButton,
  Switch,
  Divider
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CustomSelectWithInput from '../../CustomSelectWithInput'

const GeneralTab = ({
  project,
  projectName,
  handleProjectNameChange,
  projectNameError,
  environment,
  handleEnvironmentChange,
  resolutions,
  handleResolutionsChange,
  allIssueTypes,
  projectIssueTypes,
  projectIssueTypesError,
  handleProjectIssueTypesChange,
  loginRequired,
  handleLoginRequiredChange
}) => {
  return (
    <>
      <Box className="projectSettingsTextItemContainer">
        <TextField
          className="projectSettingsTextItem"
          label="Project URL"
          defaultValue={project?.url}
          disabled
        />
      </Box>
      <Box className="projectSettingsTextItemContainer itemWithErrorMessageContainer">
        <TextField
          className="projectSettingsTextItem"
          label="Project Name"
          value={projectName}
          onChange={handleProjectNameChange}
          required
          error={!!projectNameError}
          helperText={projectNameError + ' '}
        />
      </Box>
      <Box className="projectSettingsTextItemContainer">
        <FormControl className="projectSettingsTextItem">
          <CustomSelectWithInput
            value={environment}
            handleEnvironmentChange={handleEnvironmentChange}
            defaultOptions={["Staging", "Production"]}
          />
        </FormControl>
      </Box>
      <Box className="projectSettingsTextItemContainer">
        <TextField
          className="projectSettingsTextItem"
          label="Browsers"
          defaultValue="Chrome"
          disabled
        />
      </Box>
      <Divider className="projectSettingsDivider"/>
      <Alert className="projectSettingsAlert" severity="info">
        <AlertTitle className="projectSettingsAlertTitle">Important</AlertTitle>
        <span>Updates to the settings below will be applied during the next project page scan.</span>
      </Alert>
      <Box className="projectSettingsTextItemContainer">
        <FormControl error={projectIssueTypesError}>
          <InputLabel className="projectSettingsSelectLabel" variant="standard">
            UI Tests
          </InputLabel>
          <Select
            className="projectSettingsSelectItem"
            label="UI Tests"
            multiple
            value={projectIssueTypes}
            onChange={handleProjectIssueTypesChange}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={{
              PaperProps: {
                onMouseDown: (event) => event.stopPropagation(),
              },
              autoFocus: false,
            }}
          >
            {allIssueTypes.map((type) => (
              <MenuItem key={type.id} value={type.description}>
                <Checkbox checked={projectIssueTypes.indexOf(type.description) > -1} disabled={type.description === "Server response error (e.g., 401, 403)"} />
                <ListItemText primary={<span style={{ textTransform: 'capitalize' }}>{type.description}</span>} />
              </MenuItem>
            ))}
          </Select>
          {projectIssueTypesError && <FormHelperText>Please select at least one test type</FormHelperText>}
        </FormControl>
      </Box>
      <Box className="projectSettingsResolutionsContainer">
        <Typography>Select Resolutions</Typography>
        <FormControl component="fieldset" variant="standard">
          <FormGroup className="projectSettingsResolutionsItemsContainer">
            <FormControlLabel
              className="projectSettingsResolutionsItem"
              control={
                <Checkbox disabled checked={resolutions.desktop} onChange={handleResolutionsChange} name="desktop" />
              }
              label={
                <span className="projectSettingsResolutionsItemLabel">Desktop</span>
              }
            />
            <FormControlLabel
              className="projectSettingsResolutionsItem"
              control={
                <Checkbox disabled checked={resolutions.tablet} onChange={handleResolutionsChange} name="tablet" />
              }
              label={
                <span className="projectSettingsResolutionsItemLabel">Tablet</span>
              }
            />
            <FormControlLabel
              className="projectSettingsResolutionsItem"
              control={
                <Checkbox disabled checked={resolutions.mobile} onChange={handleResolutionsChange} name="mobile" />
              }
              label={
                <span className="projectSettingsResolutionsItemLabel">Mobile</span>
              }
            />
          </FormGroup>
        </FormControl>
      </Box>
      <Box className="projectSettingsLoginRequiredContainer">
        <Typography>Login Required for Scan</Typography>
        <FormControlLabel
          className="projectSettingsSwitchContainer"
          control={
            <Switch
              checked={loginRequired}
              onChange={handleLoginRequiredChange}
            />
          }
          label=""
        />
        {loginRequired && (
          <Tooltip
            title={
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: 'normal',
                  textAlign: 'left',
                  color: '#fff',
                  fontSize: '0.6875rem',
                }}
              >
                Before each page scan, Treegress will try to log in. If the login
                process fails, the scan will not start. To fix the login process,
                click on the rescan login button to update the login page information
                and check your credentials.
                <br />
                <br />
                You can disable the login option or create a new project without login
                if you want to scan all pages in &quot;guest&quot; mode.
              </Typography>
            }
            PopperProps={{
              sx: {
                '& .MuiTooltip-tooltip': {
                  backgroundColor: 'primary.main',
                  maxWidth: '500px',
                },
              },
            }}
          >
            <IconButton size="small" sx={{ p: 0 }}>
              <InfoOutlinedIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </>
  )
}

export default GeneralTab